
(function () {
  'use strict';
  function install() {
    document.querySelectorAll('[x-ref="formContainer"]').forEach(function(root) {
      var data = root._x_dataStack && root._x_dataStack[0];
      if (["floor-mounted-golf-launch-monitor-gsa-golf-lx2-camera-based","carls-place-golf-simulator-enclosure-kit-custom-sizing-impact-screen","carls-place-pro-golf-simulator-enclosure-kit-commercial-grade-impact-screen","carls-place-curved-golf-simulator-enclosure-kit-panoramic-impact-screen","optoma-zk1320-large-venue-projector","optoma-zk1120-large-venue-projector","optoma-zu2200-large-venue-projector","optoma-zu1900-large-venue-projector","optoma-zu1700-large-venue-projector","optoma-zu1300-large-venue-projector","optoma-zu1100-large-venue-projector","green-eagle-follow-m8-auto-follow-electric-golf-push-cart-gps-app-control-3-rounds-per-charge","carls-place-ready-to-golf-garmin-r50-bundle","carls-trackman4-pro-golf-simulator-package","skytrak-diy-bundle-rtg","green-eagle-terra-electric-golf-push-cart","green-eagle-neos-electric-golf-push-cart","sig10-golf-simulator-studio-package","wittek-sl90-super-golf-ball-picker"].indexOf(decodeURIComponent(window.location.pathname.split('/products/')[1] || '').replace(/\/$/,'')) === -1) return;
      if (root.querySelector('.sg-view-selected-image')) return;
      var controls = root.querySelectorAll('[role="radiogroup"], [role="combobox"]');
      if (!controls.length) return;
      var last = controls[controls.length - 1];
      var group = last.closest('fieldset, [role="group"]') || last.parentElement;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sg-view-selected-image';
      button.textContent = 'View selected image ↑';
      button.addEventListener('click', function() {
        var gallery = root.querySelector('[x-ref="gallery_slider"], [x-ref="slider"]');
        if (!gallery) return;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = gallery.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth'});
      });
      group.insertAdjacentElement('afterend', button);
    });
  }
  var style = document.createElement('style');
  style.textContent = '.sg-view-selected-image{display:none}@media(max-width:1023px){.sg-view-selected-image{display:block;min-height:44px;margin:12px 0 20px;padding:8px 0;background:transparent;border:0;color:inherit;font:inherit;font-size:14px;text-decoration:underline;text-underline-offset:4px;cursor:pointer}.sg-view-selected-image:focus-visible{outline:2px solid currentColor;outline-offset:4px}}';
  document.head.appendChild(style);
  document.addEventListener('DOMContentLoaded', install);
  document.addEventListener('alpine:initialized', install);
  document.addEventListener('shopify:section:load', install);
  install();
  window.setTimeout(install, 1200);
  new MutationObserver(function(){ install(); }).observe(document.body,{childList:true,subtree:true});
})();

(function () {
  'use strict';
  function installCustomSize() {
    document.querySelectorAll('[x-ref="formContainer"] a').forEach(function(link) {
      if (link.textContent.trim() !== 'Contact us for custom sizing') return;
      var original = link.closest('p');
      if (!original) return;
      if (original.closest('[x-ref="formContainer"]').querySelector('.sg-custom-size-compact')) return;
      original.dataset.sgCompactSize = 'true';
      original.classList.add('sg-custom-size-original');
      var note = document.createElement('div');
      note.className = 'sg-custom-size-compact';
      var label = document.createElement('span');
      label.textContent = 'Need a custom size?';
      var contact = document.createElement('a');
      contact.href = link.getAttribute('href');
      contact.textContent = 'Contact us →';
      contact.setAttribute('aria-label', 'Contact us for custom sizing');
      note.append(label, contact);
      var button = original.closest('[x-ref="formContainer"]').querySelector('.sg-view-selected-image');
      if (button) button.insertAdjacentElement('afterend', note);
      else original.insertAdjacentElement('beforebegin', note);
    });
  }
  var style = document.createElement('style');
  style.textContent = '.sg-custom-size-compact{display:none}@media(max-width:1023px){.sg-custom-size-original{display:none!important}.sg-custom-size-compact{display:flex;align-items:center;flex-wrap:wrap;gap:0 8px;margin:4px 0 0;font-size:13px;line-height:20px;color:#626a66}.sg-custom-size-compact a{display:inline-flex;align-items:center;min-height:44px;color:#00563f;font-weight:600;text-decoration:underline;text-underline-offset:3px}.sg-custom-size-compact a:focus-visible{outline:2px solid #00563f;outline-offset:3px}.sg-view-selected-image:has(+ .sg-custom-size-compact){margin-top:4px;margin-bottom:0}.sg-custom-size-compact{margin-bottom:12px}}';
  document.head.appendChild(style);
  document.addEventListener('DOMContentLoaded', installCustomSize);
  document.addEventListener('shopify:section:load', installCustomSize);
  installCustomSize();
  window.setTimeout(installCustomSize, 1300);
  new MutationObserver(function(){ installCustomSize(); }).observe(document.body,{childList:true,subtree:true});
})();

(function(){
  function installBenefits(){
    if(!/^\/products\/(carls-place-|carls-trackman4-|skytrak-diy-bundle-rtg)/.test(location.pathname))return;
    document.querySelectorAll('.sg-product-benefits').forEach(function(section){section.classList.add('sg-carl-benefits-grid');});
  }
  var style=document.createElement('style');
  style.textContent='.sg-carl-benefits-grid .sg-product-benefits__grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:0 24px!important}.sg-carl-benefits-grid .sg-product-benefits__grid article{display:flex!important;align-items:flex-start;gap:12px;border-top:1px solid #d6dcd6;padding:16px 0!important;min-width:0}.sg-carl-benefits-grid .sg-product-benefits__grid article strong{display:block;color:#153f30;font-weight:700}.sg-carl-benefits-grid .sg-product-benefits__grid article p{color:#59655e;line-height:1.5;margin:6px 0 0}.sg-carl-benefits-grid .sg-product-benefits__icon{background:#eee8d5;flex-shrink:0}@media(max-width:1023px){.sg-carl-benefits-grid .sg-product-benefits__grid{gap:0 16px!important}.sg-carl-benefits-grid .sg-product-benefits__grid article{flex-direction:column;gap:8px;padding:12px 0!important}.sg-carl-benefits-grid .sg-product-benefits__grid article strong{font-size:14px;line-height:1.35}.sg-carl-benefits-grid .sg-product-benefits__grid article p{font-size:12px;line-height:1.5}.sg-carl-benefits-grid .sg-product-benefits__icon{width:32px;height:32px}}';
  document.head.appendChild(style);
  document.addEventListener('DOMContentLoaded',installBenefits);
  document.addEventListener('shopify:section:load',installBenefits);
  installBenefits();
})();

(function(){
 function compactBenefits(){
  document.querySelectorAll('.sg-carl-benefits-grid').forEach(function(section){
   var grid=section.querySelector('.sg-product-benefits__grid');
   if(grid)grid.style.setProperty('grid-template-columns','repeat(2,minmax(0,1fr))','important');
   section.querySelectorAll('article').forEach(function(article){
    var title=article.querySelector('strong'),copy=article.querySelector('p');
    if(!title||!copy)return;
    var texts={'Made for simulator rooms':'Defines your screen and hitting space.','Matched screen and frame':'Screen and frame sized to fit together.','U.S. standard shipping':'Standard shipping for U.S. orders.','30-day returns':'Eligible unused items: returns within 30 days.','Check return eligibility':'Custom and installed items may be non-returnable.'};
    if(texts[title.textContent.trim()])copy.textContent=texts[title.textContent.trim()];
   });
  });
 }
 document.addEventListener('DOMContentLoaded',compactBenefits);
 compactBenefits();
})();

(function(){var style=document.createElement('style');style.textContent='@media(min-width:1024px){.sg-custom-size-original{display:none!important}.sg-custom-size-compact{display:flex;align-items:center;flex-wrap:wrap;gap:0 8px;margin:4px 0 12px;font-size:13px;line-height:20px;color:#626a66}.sg-custom-size-compact a{display:inline-flex;align-items:center;min-height:44px;color:#00563f;font-weight:600;text-decoration:underline;text-underline-offset:3px}.sg-custom-size-compact a:focus-visible{outline:2px solid #00563f;outline-offset:3px}}';document.head.appendChild(style);})();
(function(){
 function joinPanels(){
  document.querySelectorAll('.sg-shop-finance').forEach(function(inner){
   var panel=inner.closest('[id="product-liquid"]');
   if(!panel || !panel.querySelector('a[href^="tel:"]'))return;
   panel.classList.add('sg-product-finance-call');panel.style.setProperty('margin-top','0','important');
   var previous=panel.previousElementSibling;
   if(previous && previous.querySelector('klarna-placement') && !previous.textContent.trim()){
    previous.classList.add('sg-empty-finance-placement');previous=previous.previousElementSibling;
   }
   if(previous && previous.id !== 'product-title' && (previous.querySelector('[class*="price"]') || previous.classList.contains('flex-wrap') || previous.textContent.includes('$'))){
    previous.classList.add('sg-price-joined');previous.style.setProperty('margin-bottom','0','important');previous.style.setProperty('padding-bottom','0','important');
   }
  });
 }
 var style=document.createElement('style');
 style.textContent='.sg-empty-finance-placement{display:none!important}.sg-price-joined{margin-bottom:0!important;padding-bottom:0!important}.sg-product-finance-call{margin-top:0!important}';
 document.head.appendChild(style);
 document.addEventListener('DOMContentLoaded',joinPanels);
 new MutationObserver(joinPanels).observe(document.body,{childList:true,subtree:true});
 joinPanels();
})();

/* Reset unmapped projector-only variants to the product gallery image. */
(function(){
 var ids=['55211572920657','55211573051729','55211573150033','55211573248337','55211573379409','55211573608785','55211574690129'],last='';
 function sync(){
  var id=new URLSearchParams(location.search).get('variant');
  if(id===last)return;last=id;
  if(ids.indexOf(id)===-1)return;
  var button=document.querySelector('button[aria-label="View image 1 of 7"]') ||
    Array.prototype.find.call(document.querySelectorAll('button'),function(b){return /^View image 1 of /.test(b.getAttribute('aria-label')||'');});
  if(button)button.click();
 }
 function boot(){sync();setInterval(sync,250);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
